import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { StylesService } from '@frontend/vanilla/core';

import { MyBetsListContext, MyBetsSlipEditBetHistoryViewModel } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsEditBetHistoryService } from '../../services/my-bets-edit-bet-history.service';

@Injectable()
export class MyBetsPrintEditBetHistoryResolver {
    myBetsListContext = new MyBetsListContext();

    constructor(
        private editBetHistoryService: MyBetsEditBetHistoryService,
        private stylesService: StylesService,
    ) {}

    async resolve(routeSnapshot: ActivatedRouteSnapshot): Promise<MyBetsSlipEditBetHistoryViewModel[]> {
        const betslipId = routeSnapshot.queryParamMap.get('betnumber');
        const associatedAccount = routeSnapshot.queryParamMap.get('associatedAccount');

        if (!betslipId) {
            return [];
        }

        await Promise.all([this.editBetHistoryService.getEditBetBetslips(betslipId, associatedAccount), this.stylesService.load('print')]);
        const editBetHistoryBetslips = this.editBetHistoryService.editBetHistoryBetslips;

        return editBetHistoryBetslips;
    }
}
